import React from 'react';
import { Trans } from 'react-i18next';

export default function TaskSentMessage() {
  return <>
    <Trans
      i18nKey='description.seeTheProgress'
      components={{ 1: <a href='/tasks' /> }}
    /><Trans i18nKey='dot'>.</Trans>
  </>;
}
